import React from 'react'
import { Fade, Zoom } from "react-awesome-reveal";

const SectionSix = () => {

    const tableStyle: React.CSSProperties = {
        borderCollapse: 'collapse',
        width: '100%',
        backgroundColor: '#2b2b2b',
        color: 'white',
        // minWidth:"1000px"
    };


    const thStyle: React.CSSProperties = {
        backgroundColor: '#F09819',
        color: 'black',
        padding: '8px',
        border: '1px solid white',
        textAlign: 'center',
    };


    const tdStyle: React.CSSProperties = {
        padding: '8px',
        border: '1px solid white',
        textAlign: 'center',
        backgroundColor: '#84B7FF',
    };

    return (
        <div className="container-fluid">

            <div className="col-12 section-header">
                <Fade direction="down">
                    <h3>Portfolio wise <span style={{ color: "#F09819" }}>DLG Disclosure</span></h3>
                    <p>As per the Reserve Bank of India (Digital Lending) Directions, 2025 (dt.08/05/2025) </p>
                </Fade>
            </div>


            <div className="product-stats">
                <Fade direction='down'>
                    <div className="col-12 items">

                        <Fade cascade damping={0.3}>

                            <table style={tableStyle}>
                                <thead>
                                    <tr>
                                        <th style={thStyle} >
                                            Portfolio Details as on 30 June, 2025
                                        </th>
                                        <th style={thStyle}>Cohort Size</th>
                                        <th style={thStyle}>DLG Placed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={tdStyle}>Portfolio 1</td>
                                        <td style={tdStyle}>₹ 25,00,00,000</td>
                                        <td style={tdStyle}>₹ 1,25,00,000</td>
                                    </tr>
                                    <tr>
                                        <td style={tdStyle}>Portfolio 2</td>
                                        <td style={tdStyle}>₹ 25,00,00,000</td>
                                        <td style={tdStyle}>₹ 1,25,00,000</td>
                                    </tr>
                                </tbody>
                            </table>

                        </Fade>

                    </div>
                </Fade>
            </div>


        </div>
    )
}

export default SectionSix
